import React from 'react';
import "./notfound.scss"
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { pageinputAction, searchinputAction, pgmFilterButtonAction } from '../../actions/pgmAction';
import { PATH_URL } from '../../constants/path/path';

const NotFoundPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleGoHomeClick = () => {
        navigate(PATH_URL.HOME_PAGE_URL);
        window.scroll(0, 0);
        dispatch(pageinputAction(1));
        var seardata = {
          value: "",
        };
        dispatch(searchinputAction(seardata));
        dispatch(pgmFilterButtonAction("pending"));
      }
    return (
        <div className='Notfound_container'>
        <main classNameName="bl_page404">
            <h1>Error 404. The page does not exist</h1>
            <p>Sorry! The page you are looking for can not be found. Perhaps the page you requested was moved or deleted. It is also possible that you made a small typo when entering the address. Go to the main page.
            </p>
            <div className="bl_page404__wrapper">
                <div className="bl_page404__el1"></div>
                <div className="bl_page404__el2"></div>
                <div className="bl_page404__el3"></div>
                <div className="bl_page404__link cursor-pointer"onClick={handleGoHomeClick}>go home</div>
            </div>
        </main>
        </div>
    );
}

export default NotFoundPage;
